import { useIsSignedIn } from "../platform/session";
import type { PageProps } from "./pageProps";
import { LandingPage } from "./publicPages";
import { FeedPage } from "./signedInPages";

/**
 * `/` is two pages: the landing page for an anonymous visitor (prerendered, indexed) and the feed for a
 * signed-in one. The prerender and a hydrating page show the landing page; a session switches it to the feed.
 */
export const HomePage = (props: PageProps) => (useIsSignedIn() ? <FeedPage {...props} /> : <LandingPage {...props} />);
